import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthSessionService } from '@modules/auth/auth-session.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { LocalStorageService } from './storage/local-storage-service';
import { I18nService } from '@shared/i18n/i18n.service';
import { ThemeService } from '@shared/services/theme.service';

import { TabConflictOverlayComponent } from '@components/tab-conflict-overlay/tab-conflict-overlay.component';
import { TabSyncService } from 'app/core/services/tab-sync.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TabConflictOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private tabSyncService = inject(TabSyncService);
  private localStorage = inject(LocalStorageService);
  private permissionsService = inject(NgxPermissionsService);
  private authSession = inject(AuthSessionService);
  private i18n = inject(I18nService);
  private themeService = inject(ThemeService);

  ngOnInit() {
    this.themeService.init();
    this.i18n.initialize();
    this.authSession.init();
    this.permissionsService.loadPermissions(this.localStorage.getPermissions());
  }
}
